export const AiPromptRoleInvalidTypes = [
  'SYSTEM',
  'SYS',
  'USER',
  'SUPER_USER',
  'AGENT',
  'ANY',
  'ANY_ONE',
  'ALL',
  'EVERYONE',
  'NULL',
  'INVALID',
  'UNDEFINED',
  'NONE',
  'NO_ONE',
  'ADMIN',
  'ADMINISTRATOR',
  'SELF',
  'PLAYER',
  'CASE',
  'SCENARIO'
]

export const AiPromptRoleTypes = [
  'NULL',
  'ANYONE',
  'PROVIDER',
  'PATIENT_0',
  'PATIENT_1',
  'PATIENT_2',
  'PATIENT_3',
  'PATIENT_4',
  'PATIENT_5',
  'PATIENT_6',
  'PATIENT_7',
  'PATIENT_8',
  'PATIENT_9'
]